
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/check-your-email",
      function () {
        return require("private-next-pages/check-your-email.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/check-your-email"])
      });
    }
  